import Icon from '../components/Icon';

export const svgContents = (
  <>
    <path
      fill="#EDB326"
      d="M11.25 4a.75.75 0 0 0 1.5 0V2a.75.75 0 0 0-1.5 0zM18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0M1.25 12a.75.75 0 0 1 .75-.75h2a.75.75 0 0 1 0 1.5H2a.75.75 0 0 1-.75-.75M20 11.25a.75.75 0 0 0 0 1.5h2a.75.75 0 0 0 0-1.5zM12 22.75a.75.75 0 0 1-.75-.75v-2a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-.75.75M19.601 19.601a.75.75 0 0 1-1.06 0l-1.415-1.414a.75.75 0 1 1 1.061-1.06l1.414 1.414a.75.75 0 0 1 0 1.06M5.813 6.873a.75.75 0 0 0 1.06-1.06L5.46 4.399a.75.75 0 0 0-1.06 1.06zM19.601 4.399a.75.75 0 0 1 0 1.06l-1.414 1.415a.75.75 0 1 1-1.06-1.061l1.414-1.414a.75.75 0 0 1 1.06 0M6.873 18.187a.75.75 0 1 0-1.06-1.06L4.399 18.54a.75.75 0 1 0 1.06 1.06z"
    />
  </>
);

const Weather32Colored = Icon('weather-32-colored', svgContents);

export default Weather32Colored;
